module.exports = __webpack_public_path__ + "img/work.ae7f437c.svg";